import { useEffect } from "react";
import { useRegister, SUGGESTED_WITHDRAWAL } from "./RegisterContext";

/* ── Alert icon (inline SVG) ───────────────────────── */
const IconAlert = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

/* ── Scoped CSS ─────────────────────────────────────── */
const BANNER_CSS = `
  .wb-banner {
    display: flex; align-items: center; gap: 12px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgba(255,168,0,0.12), rgba(255,140,0,0.08));
    border: 1px solid rgba(255,168,0,0.3);
    border-radius: 0;
    margin: 0;
    color: #ffa800;
    font-size: 13px;
    animation: wb-slide-in 0.3s ease;
  }
  @keyframes wb-slide-in {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .wb-banner__icon {
    color: #ffa800;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  .wb-banner__text {
    flex: 1;
    color: rgba(255,255,255,0.85);
    font-size: 13px;
    line-height: 1.4;
  }
  .wb-banner__text strong {
    color: #ffa800;
  }
  .wb-banner__btn-primary {
    padding: 6px 14px;
    border: none;
    border-radius: 7px;
    background: linear-gradient(135deg, #ffa800, #ff8c00);
    color: #fff;
    font-size: 12px; font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.15s, transform 0.1s;
  }
  .wb-banner__btn-primary:hover {
    opacity: 0.9;
    transform: scale(1.02);
  }
  .wb-banner__btn-dismiss {
    padding: 6px 12px;
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 7px;
    background: transparent;
    color: rgba(255,255,255,0.5);
    font-size: 12px; font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: border-color 0.15s, color 0.15s;
  }
  .wb-banner__btn-dismiss:hover {
    border-color: rgba(255,255,255,0.3);
    color: #fff;
  }
`;

export default function WithdrawalBanner() {
  const { session, thresholdReached, setWithdrawalModalVisible, dismissWithdrawalBanner } = useRegister();

  // Inject scoped styles once
  useEffect(() => {
    const styleId = "withdrawal-banner-css";
    if (!document.getElementById(styleId)) {
      const el = document.createElement("style");
      el.id = styleId;
      el.textContent = BANNER_CSS;
      document.head.appendChild(el);
    }
  }, []);

  if (!thresholdReached || !session) return null;

  const suggested = Math.min(SUGGESTED_WITHDRAWAL, session.currentCash);

  return (
    <div className="wb-banner">
      <div className="wb-banner__icon"><IconAlert /></div>
      <div className="wb-banner__text">
        <strong>Cash register exceeds {SUGGESTED_WITHDRAWAL} TND.</strong>{" "}
        Please perform a withdrawal of {suggested.toFixed(3)} TND.
      </div>
      <button className="wb-banner__btn-primary" onClick={() => setWithdrawalModalVisible(true)}>
        Withdraw now
      </button>
      <button className="wb-banner__btn-dismiss" onClick={dismissWithdrawalBanner}>
        Later
      </button>
    </div>
  );
}